import {useVideoPlayer, useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';

import {Icon} from '@components/@icons';
export const VideoFullscreenButton = () => {
    const {enterFullscreen, exitFullscreen} = useVideoPlayer();

    const isFullscreen = useVideoPlayerState(s => s.isFullscreen);

    const handleFullscreen = () => {
        if (isFullscreen) {
            exitFullscreen();
        } else {
            enterFullscreen();
        }
    };

    const props = {
        fill: 'var(--color-icon-player)',
        width: 24,
        height: 24,
    };

    return (
        <VideoControlsItem onClick={handleFullscreen}>
            {isFullscreen ? (
                <Icon name="minimize" {...props} />
            ) : (
                <Icon name="maximize" {...props} />
            )}
        </VideoControlsItem>
    );
};
